import type { CSSProperties } from 'react'
import { useTranslation } from '../../lib/i18n'

export function NoDataScreen() {
  const { t } = useTranslation()

  return (
    <div style={styles.root}>
      <div style={styles.title}>{t('no_data.title')}</div>
      <div style={styles.text}>{t('no_data.text')}</div>
    </div>
  )
}

const styles: Record<string, CSSProperties> = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '0 32px',
    textAlign: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: 'var(--tg-theme-text-color, #000)',
    marginBottom: 8,
  },
  text: {
    fontSize: 15,
    lineHeight: 1.5,
    color: 'var(--tg-theme-hint-color, #888)',
  },
}
